<!-- «Mi QR Perrón» va FUERA de los estados del resumen (Q5): ni la carga, ni el error, ni el vacío lo esconden. -->
<app-profile-qr />

@switch (state().status) {
  @case ('loading') {
    <div class="coins-skeleton" aria-busy="true">
      <div class="coins-skeleton__card">
        <span class="coins-skeleton__line coins-skeleton__line--title"></span>
        <span class="coins-skeleton__line coins-skeleton__line--big"></span>
        <span class="coins-skeleton__line coins-skeleton__line--meta"></span>
      </div>
      @for (row of [1, 2, 3]; track row) {
        <div class="coins-skeleton__row">
          <span class="coins-skeleton__line coins-skeleton__line--meta"></span>
        </div>
      }
    </div>
  }

  @case ('error') {
    <div class="coins-error" role="alert">
      <p class="coins-error__text">{{ copy.LOAD_ERROR }}</p>
      <app-button variant="secondary" size="sm" (click)="retry()">{{ copy.RETRY }}</app-button>
    </div>
  }

  @case ('loaded') {
    @if (summary(); as data) {
      @if (data.entries.total === 0) {
        <div class="coins-empty">
          <img ngSrc="images/logo/comunity.png" width="450" height="512" alt="" class="coins-empty__mascot" />
          <p class="coins-empty__title">{{ copy.EMPTY_TITLE }}</p>
          <p class="coins-empty__text">{{ copy.EMPTY_TEXT }}</p>
          <app-button variant="primary" size="sm" (click)="openRedeem()">{{ copy.REDEEM_CTA }}</app-button>
        </div>
      } @else {
        <section class="coins-summary" aria-labelledby="coins-summary-title">
          <h2 id="coins-summary-title" class="coins-summary__title">{{ copy.TITLE }}</h2>

          <dl class="coins-summary__stats">
            <div class="coins-stat">
              <dt class="coins-stat__label">{{ copy.BALANCE_LABEL }}</dt>
              <dd class="coins-stat__value coins-stat__value--balance">{{ balanceLabel() }}</dd>
            </div>
            <div class="coins-stat">
              <dt class="coins-stat__label">{{ copy.LIFETIME_LABEL }}</dt>
              <dd class="coins-stat__value coins-stat__value--lifetime">{{ lifetimeLabel() }}</dd>
              <dd class="coins-stat__hint">{{ copy.LIFETIME_HINT }}</dd>
            </div>
          </dl>

          <p class="coins-summary__vip" [class.coins-summary__vip--active]="data.early_access">{{ vipText() }}</p>
          @if (valueText(); as value) {
            <p class="coins-summary__value">{{ value }}</p>
          }

          <div class="coins-summary__actions">
            <app-button variant="primary" size="sm" (click)="openRedeem()">{{ copy.REDEEM_CTA }}</app-button>
            <a routerLink="/perron-coins" class="coins-summary__how">{{ copy.HOW_LINK }}</a>
          </div>
        </section>

        <section class="coins-history" aria-labelledby="coins-history-title">
          <h3 id="coins-history-title" class="coins-history__title">{{ copy.HISTORY_TITLE }}</h3>
          <ul class="coins-history__list" role="list">
            @for (entry of entries(); track entry.id) {
              <li class="coins-entry">
                <span class="coins-entry__main">
                  <span class="coins-entry__type">{{ typeLabel(entry.type) }}</span>
                  <span class="coins-entry__meta">
                    <span class="coins-entry__date">{{ formatDate(entry.created_at) }}</span>
                    @if (entry.preorder_id !== null) {
                      <a class="coins-entry__order" [routerLink]="['/perfil/pedidos', entry.preorder_id]">
                        {{ orderRef(entry.preorder_id) }}
                      </a>
                    }
                  </span>
                </span>
                <span
                  class="coins-entry__amount"
                  [class.coins-entry__amount--credit]="entry.amount >= 0"
                  [class.coins-entry__amount--debit]="entry.amount < 0"
                  >{{ signedAmount(entry.amount) }}</span
                >
              </li>
            }
          </ul>

          @if (hasMore()) {
            <div class="coins-history__more-wrap">
              <button
                type="button"
                class="coins-history__more"
                [attr.aria-busy]="loadingMore() || null"
                (click)="loadMore()"
              >
                @if (loadingMore()) {
                  <app-icon [icon]="spinnerIcon" [size]="16" class="coins-history__spinner" aria-hidden="true" />
                }
                {{ copy.LOAD_MORE }}
              </button>
            </div>
          }
        </section>
      }
    }
  }
}
